import { Component, Input, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { ProviderInfo } from 'src/app/obstacle/model/provider-info.model'
import { Layers } from 'src/app/shared/layers-config/layers'

const COLLAPSED_STORAGE_KEY = 'obstacle-provider2-data-collapsed'

@Component({
  selector: 'app-obstacle-provider2-data',
  templateUrl: './obstacle-provider2-data.component.html',
  standalone: false,
})
export class ObstacleProvider2DataComponent implements OnInit {
  public layerIds = Layers
  public isAccidentsLayerVisible: boolean | undefined
  public isBdvVisible: boolean | undefined
  public isConstructionSiteVisible: boolean | undefined
  public isCollapsed = true
  @Input() providerInfo$!: Observable<ProviderInfo>

  constructor(private appState: AppStateService) {
    const layers = this.appState.selectLayers()
    this.isAccidentsLayerVisible = layers?.some((layer) => layer === Layers.Provider2Accidents.name)
    this.isBdvVisible = layers?.some((layer) => layer === Layers.Provider2Bdv.name)
    this.isConstructionSiteVisible = layers?.some(
      (layer) => layer === Layers.Provider2ConstructionSites.name,
    )
  }

  ngOnInit(): void {
    this.isCollapsed = this.getStoredCollapsedState()
  }

  get selectedLayerCount(): number {
    return [this.isAccidentsLayerVisible, this.isBdvVisible, this.isConstructionSiteVisible].filter(
      Boolean,
    ).length
  }

  get allLayerCount(): number {
    return [this.isAccidentsLayerVisible, this.isBdvVisible, this.isConstructionSiteVisible].length
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed
    this.storeCollapsedState()
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.Provider2Accidents.name:
        this.isAccidentsLayerVisible = !this.isAccidentsLayerVisible
        break
      case Layers.Provider2Bdv.name:
        this.isBdvVisible = !this.isBdvVisible
        break
      case Layers.Provider2ConstructionSites.name:
        this.isConstructionSiteVisible = !this.isConstructionSiteVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          !(layer == Layers.Provider2Bdv.name) &&
          !(layer == Layers.Provider2Accidents.name) &&
          !(layer == Layers.Provider2ConstructionSites.name),
      )
    if (this.isAccidentsLayerVisible) {
      layers.push(Layers.Provider2Accidents.name)
    }
    if (this.isBdvVisible) {
      layers.push(Layers.Provider2Bdv.name)
    }
    if (this.isConstructionSiteVisible) {
      layers.push(Layers.Provider2ConstructionSites.name)
    }
    this.appState.setState(AppPaths.Obstacle, {
      layers: layers?.toString(),
    })
  }

  private getStoredCollapsedState(): boolean {
    if (typeof localStorage === 'undefined') {
      return true
    }

    const storedState = localStorage.getItem(COLLAPSED_STORAGE_KEY)

    if (storedState === null) {
      return true
    }

    return storedState === 'true'
  }

  private storeCollapsedState(): void {
    if (typeof localStorage === 'undefined') {
      return
    }

    localStorage.setItem(COLLAPSED_STORAGE_KEY, String(this.isCollapsed))
  }
}
